import React, { Component } from 'react'
import { Spin, Icon, Form, Button } from 'antd'
import CKEditor from 'ckeditor4-react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getPP, updatePP } from '../../../../core/actions/ppcontents';

const antIcon = <Icon type="loading" style={{ fontSize: 50 }} spin />

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      content: '',
      reserve: '',
      newContent: ''
    }
  }

  componentDidMount() {
    this.props.getPP()
  }

  componentWillReceiveProps(nextProps) {
    let { ppContent, loading, ppContentSuccess } = nextProps
    if (ppContent.content.length > 0) {
      this.setState({
        content: ppContent.content,
        reserve: ppContent.content
      })
    }
    this.setState({
      loading: loading
    })
    if (ppContentSuccess.length > 0) {
      this.props.getPP()
    }
  }

  resetContent = () => {
    const { reserve } = this.state
    this.setState({
      newContent: reserve
    })
  }

  updateContent = () => {
    const { newContent } = this.state
    let ppPef = {
      content: newContent
    }
    this.props.updatePP(ppPef)
  }

  render() {
    const { loading, content, newContent } = this.state
    return (
      <div className="pp-form">
        <Spin spinning={loading} indicator={antIcon}>
          <Form>
            {/* <Form.Item label="Post Content" /> */}
            <CKEditor
              onBeforeLoad={(CKEditor) => (CKEditor.disableAutoInline = true)}
              data={newContent || content}
              config={{
                toolbar: [['Source', 'Format', 'Link', 'Unlink', 'NumberedList', 'BulletedList', 'Blockquote', 'Indent', 'Outdent' ]],
                height: 350,
                format_tags: 'p;h3'
              }}
              onChange={(evt) => {
                this.setState({
                  newContent: evt.editor.getData()
                });
              }}
            />
            <Form.Item className="button-holder">
              <Button type="primary" onClick={(e) => this.updateContent()}>
                Update
              </Button>
              <Button className="reset-btn" onClick={(e) => this.resetContent()}>
                Reset
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  ppContent: state.ppContents.ppContent,
  loading: state.ppContents.loading,
  ppContentSuccess: state.ppContents.ppContentSuccess,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getPP,
  updatePP
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy)
